export default {"src":"/_next/static/media/art_gallery.1ee99365.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};